module.exports = __webpack_public_path__ + "img/image 11.6f36b2fd.png";